import instance from "./request";
console.log('确实提前定义好了函数--------------------------------------------------')

//上传课程
export const addClasses = (data) => instance.post('/trainClass/addClasses', data)

//上传题库
export const addTopics = (data) => instance.post('/trainTi/addTopics', data)

//题库列表
export const topicsLibrarySelect = () => instance.get('/trainTi/tipicSelect')

//题库中的所有题目
export const tipics = (data) => instance.post('/trainTi/tipics', data)

//新增培训方案
export const addTrainProgram = (data) => instance.post('/trainProgram/add', data)

//修改培训方案
export const updateTrainProgram = (data) => instance.post('/trainProgram/edit', data)


//培训方案详情
export const trainProgramInfo = (id) => instance.get('/trainProgram/info/' + id)

//考核结束
export const examOver = (data) => instance.post('/train/over', data)

//培训管理页面的数据统计
export const getSummary = () => instance.get('/train/summary')

//修改 培训结果数据
export const trainEdit = (data) => instance.post('/train/edit', data)